import { Session as TalkSession } from '@talkjs/react'
import { type ReactNode } from 'react'

import { useChatContext } from './ChatContext'

type SessionProps = {
  children: ReactNode
}

export function Session({ children }: SessionProps) {
  const { me, isLoading, onUnreadsChange } = useChatContext()

  if (isLoading || !me) {
    return <>{children}</>
  }

  return (
    <TalkSession
      appId={process.env.REACT_APP_TALKJS_APP_ID}
      userId={me.uuid}
      onUnreadsChange={onUnreadsChange}
      token={me.talkJsToken}
    >
      {children}
    </TalkSession>
  )
}
